export default __webpack_public_path__ + "static/media/book.c79fe9aa.svg";